import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from 'src/app/app.component';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-global-config',
  templateUrl: './global-config.component.html',
  styleUrls: ['./global-config.component.scss']
})
export class GlobalConfigComponent implements OnInit {

  isSpinning = false;
  fileList: any[] = [];
  titleConfig: any;
  logoConfig: any;
  validateModuleForm!: FormGroup;
  previewVisible = false;
  imageLoading = false;

  constructor(
    private fb: FormBuilder,
    private service: ConfigService,
    private message: NzMessageService,
    private translate: TranslateService,
    private appComponent: AppComponent,
    private domSanitizer: DomSanitizer,
    private modelService: NzModalService,
  ) {
    this.getConfig('ANGULAR_TITLE');
    this.getConfig('ANGULAR_LOGO');
  }

  ngOnInit(): void {
    this.validateModuleForm = this.fb.group({
      title: [[], [Validators.required]],
    });
  }

  getConfig(key: string) {
    this.service.getDictByType({ dictType: 'GLOBAL_CONFIG', dictKey: key }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData.length) {
        const { dictValue } = rtnData[0];
        if (key === 'ANGULAR_TITLE') {
          this.titleConfig = rtnData[0];
          this.validateModuleForm.setValue({ title: dictValue });
        }
        if (key === 'ANGULAR_LOGO') {
          this.logoConfig = rtnData[0];
          dictValue && (this.fileList = [{
            uid: 'logo',
            name: 'logo',
            url: this.domSanitizer.bypassSecurityTrustResourceUrl(dictValue),
            status: 'done',
            originUrl: dictValue,
          }]);
        }
      }
    });
  }

  onBeforeUpload = (file: any): boolean => {
    if (!file.type?.startsWith('image/')) {
      file.status = 'error';
      this.message.create('error', '');
    } else {
      this.getBase64(file).then((url: any) => {
        file.url = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        file.originUrl = url;
        this.fileList = [file];
      });
    }
    return false;
  };

  getBase64(file: any): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      this.imageLoading = true;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onloadend = () => this.imageLoading = false;
      reader.onerror = error => {
        this.imageLoading = false;
        reject(error)
      };
    });
  }

  onCancel() {
    this.validateModuleForm.setValue({ title: this.titleConfig.dictValue });
    if (this.logoConfig.dictValue) {
      this.fileList = [{
        uid: 'logo',
        name: 'logo',
        url: this.domSanitizer.bypassSecurityTrustResourceUrl(this.logoConfig.dictValue),
        originUrl: this.logoConfig.dictValue,
      }]
    } else {
      this.fileList = [];
    }
  }

  onSaveConfirm() {
    this.modelService.confirm({
      nzTitle: this.translate.instant('CHANGE_GLOBAL_CONFIG_CONFIRM'),
      nzContent: this.translate.instant('CHANGE_GLOBAL_CONFIG_INFO'),
      nzOnOk: () => this.onSave(),
      nzWidth: 450,
    });
  }

  async onSave() {
    if (this.validateModuleForm.valid && !(this.fileList.length && this.fileList[0]?.status === 'error')) {
      this.isSpinning = true;
      const { title } = this.validateModuleForm.value;
      this.service.addOrUpdate({ ...this.titleConfig, dictValue: title }).subscribe(result => {
        const { rtnCode } = result;
        if (rtnCode === 10000) {
          //this.appComponent.setMenuTitle();
        }
      });
      this.service.addOrUpdate({ ...this.logoConfig, dictValue: this.fileList.length ? this.fileList[0].originUrl : '' }).subscribe(result => {
        const { rtnCode } = result;
        if (rtnCode === 10000) {
          //this.appComponent.setMenuLogo();
          this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
        }
        this.isSpinning = false;
      });
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

}
